__turbopack_context__.v({
  "divider": "SectionWrapper-module-scss-module__I7BIBq__divider",
  "navigationSection": "SectionWrapper-module-scss-module__I7BIBq__navigationSection",
});
